import { toRaw, unref } from 'vue'
import L from 'leaflet'
// import * as echarts from 'echarts'
import { ShipxyOptions } from '@map-sdk/sdk/config'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { CommUtils } from '@map-sdk/sdk/utils/CommUtils'
import { TidesPopupWindow } from '@map-sdk/sdk/plugins/weather/Tides/TidesPopupWindow'
import { GetAllTidePort } from '@map-sdk/sdk/plugins/weather/Tides//data'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'

interface TooltipFormatterContext {
  value: [Date, number]
  dataIndex: number
  seriesIndex: number
  portname: string
}

export class Tide {
  name = ''
  id = ''
  timezone = ''
  city = ''
  province = ''
  lat = 0
  lon = 0
  tidaldatum = ''
  tidetype = ''
  minviewzoom = 3
  opacity = 0.9
  offset = [0, 80]
  direction = 'right'
  from = 1
  cnname = ''
  enname = ''
  cncountry = ''
  encountry = ''
  nodeid = 0
  country = ''
}

class Layers {
  public static layerMap: MyMap
  public static layerGroup: L.FeatureGroup<any>
}

/**
 * 潮服务
 */
export class TideService {
  private _map: any
  private _Tides: Tide[]
  private partTime!: number
  private leftDate!: Date
  private rightDate!: Date
  private currentTideTitle!: string
  private currentId!: number
  private leftTime: any
  private rightTime: any
  constructor(map: MyMap) {
    Layers.layerMap = toRaw(unref(map))
    Layers.layerGroup = L.featureGroup().addTo(Layers.layerMap)
    this._map = toRaw(unref(map))
    this._Tides = []
    this._map.options.closePopupOnClick = false
  }
  private _Event = {
    moveend: () => this._drawTides(),
    zoomend: () => this._drawTides(),
  }
  addTides(): void {
    const tidesGuoWaiUrl = ShipxyOptions.weather.tidesGuoWaiUrl.replace(
      '{k}',
      this._map.options.ak
    )
    console.log('TODO:请求接口', tidesGuoWaiUrl)

    if (GetAllTidePort.status === 0 && GetAllTidePort.data) {
      const data = GetAllTidePort.data
      for (const [i, item] of data.entries()) {
        const tide = new Tide()

        tide.id = item.id.toString()
        tide.nodeid = item.id
        tide.from = 2
        tide.cnname = item.cnname
        tide.enname = item.enname
        tide.cncountry = item.cncountry
        tide.encountry = item.encountry
        tide.lat = item.lat
        tide.lon = item.lon
        tide.timezone = item.timezone
        tide.tidaldatum = item.datumn
        tide.tidetype = item.tidetype
        tide.minviewzoom =
          i % 20 === 0 ? 1 : i % 9 === 0 ? 3 : i % 3 === 0 ? 5 : 7
        tide.name = CommUtils.isEmpty(tide.cnname) ? item.enname : tide.cnname
        tide.country = CommUtils.isEmpty(tide.cncountry)
          ? item.encountry
          : tide.cncountry

        this._Tides.push(tide)

        // 优化部分
        const tideObj = Object.assign({}, tide)
        tideObj.id = `${tideObj.id}_360`
        if (tide.lon < 0) {
          tideObj.lon += 360
        }
        if (tide.lon > 0) {
          tideObj.lon -= 360
        }
        this._Tides.push(tideObj)
      }
      this._drawTides()
    }

    this._map.off('moveend', this._Event.moveend)
    this._map.on('moveend', this._Event.moveend)
  }
  _drawTides() {
    Layers.layerGroup.remove()
    Layers.layerGroup = L.featureGroup().addTo(Layers.layerMap)
    const zoom = this._map.getZoom()
    const bounds = this._map.getBounds()
    for (let i = 0; i < this._Tides.length; i++) {
      bounds.contains(L.latLng(this._Tides[i].lat, this._Tides[i].lon))
      if (zoom >= this._Tides[i].minviewzoom && 2 == this._Tides[i].from) {
        this._drawTide_guowai(this._Tides[i])
      }
    }
  }
  close() {
    if (Layers.layerGroup) {
      Layers.layerGroup.remove()
      this._Tides = []
    }
    this._map.off('zoomend', this._Event.zoomend)
  }
  _drawTide_guowai(item: Tide) {
    let utctime: string
    if (CommUtils.isEmpty(item.timezone)) utctime = ''
    else {
      let str = '+'
      Number(item.timezone) < 0 && (str = '-')
      utctime = `UTC${str}${Math.abs(Number(item.timezone))}`
    }
    const iconUrl = `${ShipxyOptions.weather.icon_base_url}/${ShipxyOptions.weather.icon_types.潮汐.icon}`
    const marker = L.marker(L.latLng(item.lat, item.lon), {})
    marker.setIcon(
      L.icon({
        iconUrl,
        iconSize: [18, 18],
      })
    )
    marker.on('click', () => {
      // TODO: 不使用该方式最后使用组件的方式进行处理
      return
      let tbodymove = document.querySelector('#tbodymove') as HTMLDivElement
      if (!tbodymove) {
        new TidesPopupWindow(this._map).show()
        tbodymove = document.querySelector('#tbodymove') as HTMLDivElement
      }
      tbodymove.style.display = 'block'
      this.partTime = 86400000
      this.leftDate = new Date()
      this.rightDate = new Date(this.leftDate.getTime() + this.partTime)
      this.currentTideTitle =
        `潮汐观测点` +
        `：${item.country} (${item.name})` +
        `时区` +
        `：${utctime}`
      this.currentId = item.nodeid as any
      ;(document.querySelector('#tide_title') as HTMLDivElement).innerHTML =
        this.currentTideTitle
      const tideClose = document.querySelector('#tideClose') as HTMLDivElement
      tideClose.style.background = `url(${ShipxyOptions.weather.cha}) no-repeat center`
      tideClose.onclick = function () {
        const tbodymove = document.querySelector('#tbodymove') as HTMLDivElement
        tbodymove.style.display = 'none'
      }
      this.setTidesInfoGuoWai(item)
    })
    const html = `<div class="weather-chaoxi-tooltip">
      <div class="title">潮汐观测点：${item.name}</div>
      <div class="field">时区：${utctime}</div>
      <div class="field">国家：${item.country}</div>
      <div class="field">坐标：${CanvasShipUtils.latFormatter(
        item.lat
      )}，${CanvasShipUtils.lngFormatter(item.lon)}</div>
      <div class="field">潮高基准面：${item.tidaldatum}</div>
      <div class="field" style="padding-bottom: 10px;">潮汐性质：${
        item.tidetype
      }</div>
      </div>`
    marker.bindTooltip(html, {
      opacity: 1,
      className: 'weather-chaoxi-bindTooltip',
      interactive: false,
    })
    const tooltip = marker.getTooltip() as any
    tooltip._initLayout()
    tooltip._container.style.padding = 0
    tooltip._container.style.border = 'none'
    Layers.layerGroup.addLayer(marker)
  }
  setTidesInfoGuoWai(item: { name: any }): void {
    const tideLoadingDom = document.querySelector(
      '#tide_loading'
    ) as HTMLInputElement
    const tideContentDom = document.querySelector(
      '#tide_content'
    ) as HTMLInputElement
    tideLoadingDom.style.display = 'block'
    tideContentDom.style.display = 'none'
    this.leftTime = CommUtils.dataFormat(this.leftDate, 'YYYY-MM-DD')
    this.rightTime = CommUtils.dataFormat(this.rightDate, 'YYYY-MM-DD')

    const tideDay1 = document.querySelector('#tideDay1') as HTMLInputElement
    const tideDay2 = document.querySelector('#tideDay2') as HTMLInputElement
    const tideDayTable1 = document.querySelector(
      '#tideDayTable1'
    ) as HTMLTableElement
    const tideDayTable2 = document.querySelector(
      '#tideDayTable2'
    ) as HTMLTableElement
    // const tide_img = document.getElementById('tide_img') as HTMLTableElement
    // tide_img.removeEventListener('click')
    ;(
      document.querySelector('#tide_echart_div') as HTMLTableElement
    ).style.display = 'block'

    const list = ['潮时一', '潮时二', '潮时三', '潮时四']

    let tideTimes1 = [null, null, null, null]
    let tideHeights1 = [null, null, null, null]
    let tideLowHighs1 = [null, null, null, null]

    let tideTimes2 = [null, null, null, null]
    let tideHeights2 = [null, null, null, null]
    let tideLowHighs2 = [null, null, null, null]

    tideDay1.textContent = CommUtils.dataFormat(this.leftDate, 'YYYY-MM-DD')
    tideDay2.textContent = CommUtils.dataFormat(this.rightDate, 'YYYY-MM-DD')

    for (let i = 0; i < 4; i++) {
      const row1 = tideDayTable1.rows[i]
      row1.cells[0].innerHTML = ''
      row1.cells[1].innerHTML = ''
      row1.cells[2].innerHTML = ''
      row1.cells[3].innerHTML = ''

      const row2 = tideDayTable2.rows[i]
      row2.cells[0].innerHTML = ''
      row2.cells[1].innerHTML = ''
      row2.cells[2].innerHTML = ''
      row2.cells[3].innerHTML = ''
    }

    const tideA = document.querySelectorAll('.tideA')
    const tideA0 = tideA[0] as HTMLElement
    const tideA1 = tideA[1] as HTMLElement
    tideA0.style.display = 'block'
    tideA1.style.display = 'block'

    tideA0.addEventListener('click', () => {
      this.rightDate = this.leftDate
      this.leftDate = new Date(this.leftDate.getTime() - this.partTime)
      this.setTidesInfoGuoWai(item)
      const currentTime = Date.now()
      const futureTime = currentTime + 6 * this.partTime

      if (this.rightDate.getTime() <= futureTime) {
        tideA1.style.display = 'block'
      }
      if (
        this.leftDate.getTime() <=
        new Date(ShipxyOptions.weather.tidesGuoWaiBeginDate).getTime()
      ) {
        tideA0.style.display = 'none'
      }
    })

    tideA[1].addEventListener('click', () => {
      this.leftDate = this.rightDate
      this.rightDate = new Date(this.leftDate.getTime() + this.partTime)
      this.setTidesInfoGuoWai(item)
      const currentTime = Date.now()
      const futureTime = currentTime + 6 * this.partTime

      if (this.rightDate.getTime() >= futureTime) {
        tideA1.style.display = 'none'
      }
      if (
        this.leftDate.getTime() >=
        new Date(ShipxyOptions.weather.tidesGuoWaiBeginDate).getTime()
      ) {
        tideA0.style.display = 'block'
      }
    })

    const apiUrl = ShipxyOptions.weather.tidesInfoGuoWaiUrl
      .replace('{k}', this._map.options.ak)
      .replace('{0}', `${this.currentId}`)
      .replace('{1}', this.leftTime)
      .replace('{2}', this.rightTime)

    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 0) {
          const parsedData = data.data
          if (parsedData && parsedData.overview) {
            const overviewData = parsedData.overview
            if (overviewData.length > 0) {
              tideTimes1 = [
                overviewData[0].tide_time1,
                overviewData[0].tide_time2,
                overviewData[0].tide_time3,
                overviewData[0].tide_time4,
              ]
              tideHeights1 = [
                overviewData[0].tide_height1,
                overviewData[0].tide_height2,
                overviewData[0].tide_height3,
                overviewData[0].tide_height4,
              ]
              tideLowHighs1 = [
                overviewData[0].tide_lowhigh1,
                overviewData[0].tide_lowhigh2,
                overviewData[0].tide_lowhigh3,
                overviewData[0].tide_lowhigh4,
              ]

              if (overviewData.length > 1) {
                tideTimes2 = [
                  overviewData[1].tide_time1,
                  overviewData[1].tide_time2,
                  overviewData[1].tide_time3,
                  overviewData[1].tide_time4,
                ]
                tideHeights2 = [
                  overviewData[1].tide_height1,
                  overviewData[1].tide_height2,
                  overviewData[1].tide_height3,
                  overviewData[1].tide_height4,
                ]
                tideLowHighs2 = [
                  overviewData[1].tide_lowhigh1,
                  overviewData[1].tide_lowhigh2,
                  overviewData[1].tide_lowhigh3,
                  overviewData[1].tide_lowhigh4,
                ]
              }
            }

            for (let i = 0; i < 4; i++) {
              if (tideHeights1[i]) {
                const row1 = tideDayTable1.rows[i]
                row1.cells[0].innerHTML = `${tideLowHighs1[i] || list[i]}:`
                row1.cells[1].innerHTML = tideTimes1[i] || ''
                row1.cells[2].innerHTML = '潮高' + ':'
                row1.cells[3].innerHTML = `${tideHeights1[i]}m`
              }

              if (tideHeights2[i]) {
                const row2 = tideDayTable2.rows[i]
                row2.cells[0].innerHTML = `${tideLowHighs2[i] || list[i]}:`
                row2.cells[1].innerHTML = tideTimes2[i] || ''
                row2.cells[2].innerHTML = '潮高' + ':'
                row2.cells[3].innerHTML = `${tideHeights2[i]}m`
              }
            }

            if (parsedData.detail && parsedData.detail.length > 0) {
              const detailData = parsedData.detail
              for (let i = 0, len = detailData.length; i < len; i++) {
                const detailItem = detailData[i]
                if (detailItem) {
                  for (let j = 0; j < 24; j++) {
                    const pointData: any = {}
                    pointData.name = j
                    pointData.portid = detailItem.portid
                    pointData.portname = item.name
                    pointData.date = CommUtils.replaceAll(
                      detailItem.date,
                      '-',
                      '/'
                    )
                    pointData.value = [
                      `${pointData.date} ${j}:00:00`,
                      detailItem[`h${j}`],
                    ]
                    this.setEchart(pointData)
                  }
                }
              }
            }
          }
        } else {
          console.error(data.message || 'Error fetching data')
        }

        tideLoadingDom.style.display = 'none'
        tideContentDom.style.display = 'block'
      })
      .catch((error) => {
        console.error(error)
      })
  }
  formatTooltip(vals: TooltipFormatterContext[]): string {
    const val = vals[0]
    let HTML = `<b>${val.portname}</b><br/>`
    HTML += `<div style="display: inline;">
              <div style="padding: 0; margin: 0; float: left;">${CommUtils.dataFormat(
                val.value[0],
                'hh:mm'
              )}</div>
              <div style="padding: 0; margin: 0; margin-left: 12px; float: left;">${
                val.value[1]
              }m</div>
            </div>`
    return HTML
  }

  setEchart(data: Array<{ value: [Date, number]; portname: string }>) {
    // const echartInstance = echarts.init(
    //   document.querySelector('#tide_echart_div'),
    //   'macarons'
    // )
    // const options: echarts.EChartsOption = {
    //   color: ['#2770d4'],
    //   textStyle: {
    //     color: '#999',
    //   },
    //   title: {
    //     text: '',
    //   },
    //   tooltip: {
    //     trigger: 'axis',
    //     formatter: this.formatTooltip,
    //     axisPointer: {
    //       type: 'line',
    //       animation: false,
    //       lineStyle: {
    //         color: '#19cebf',
    //         width: 2,
    //       },
    //     },
    //     backgroundColor: '#ffffffb3',
    //     borderColor: '#4572A7',
    //     borderWidth: 2,
    //     position: (
    //       _pos: any[],
    //       _contentSize: any,
    //       _offset: any,
    //       _tooltipSize: any,
    //       viewSize: { viewSize: number[] }
    //     ): [number, number] => {
    //       const offsetX = _pos[0] > viewSize.viewSize[0] / 2 ? -10 : 0
    //       return [_pos[0] + offsetX, _pos[1]]
    //     },
    //     textStyle: {
    //       color: '#333',
    //       fontFamily: 'Arial',
    //       fontSize: 13,
    //     },
    //     padding: [0, 5],
    //   } as any,
    //   xAxis: {
    //     type: 'category',
    //     splitLine: {
    //       show: false,
    //     },
    //     axisLabel: {
    //       formatter: (value: string | number | Date): string =>
    //         CommUtils.dataFormat(new Date(value), 'h'),
    //     },
    //   },
    //   yAxis: {
    //     name: `'潮高(米)`, // 这里假设 $i18n 是全局国际化对象
    //     type: 'value',
    //     boundaryGap: [0, '100%'],
    //     splitLine: {
    //       show: true,
    //       lineStyle: {
    //         type: 'dashed',
    //         color: ['#999'],
    //         width: 1,
    //       },
    //     },
    //     splitArea: {
    //       show: false,
    //       areaStyle: {
    //         color: ['#ddd', '#fff'],
    //       },
    //     },
    //     max: ({ max }: { max: number }): number => max,
    //     offset: -5,
    //   },
    //   series: [
    //     {
    //       name: '',
    //       type: 'line',
    //       showSymbol: false,
    //       hoverAnimation: true,
    //       data,
    //       areaStyle: {
    //         color: '#76a7ea',
    //       },
    //       smooth: true,
    //       lineStyle: {
    //         width: 2,
    //       },
    //     },
    //   ] as any,
    // }
    // echartInstance.setOption(options)
  }
}
